import styled from "styled-components";

export const Box = styled.div`
  .interDisplay {
    font-family: "Inter", sans-serif;
    font-weight: 400;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }

  .htc-container {
    max-width: 1000px;
    margin: 0 auto;
    background: #f9fafb;
    border-radius: 16px;
    padding: 1.5rem;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }
    .htc-summary-card.card {
    width: 100%;
}

  .htc-input-mode-toggle {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 2rem;
  }

  .htc-toggle-btn {
    display: flex;
    align-items: center;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .htc-toggle-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .htc-url-form {
    margin-bottom: 2.5rem;
  }

  .htc-input-group {
    display: flex;
    gap: 1rem;
    align-items: flex-start;
  }

  .htc-url-input-wrapper {
    position: relative;
    flex: 1;
    width: 100%;
  }

  .htc-url-hint {
    position: static;
    margin-top: 0.5rem;
    bottom: -1.75rem;
    left: 0;
    font-size: 0.8rem;
    color: #6b7280;
    font-style: italic;
  }

  .htc-custom-input {
    height: 56px;
    border-radius: 12px;
    border: 1px solid #d1d5db;
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    color: #1f2937;
    background-color: white;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  .htc-custom-input:focus {
    border-color: #4f46e5;
    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
    outline: none;
  }

  .htc-custom-input::placeholder {
    color: #9ca3af;
  }

  .htc-custom-textarea {
    border-radius: 12px;
    border: 1px solid #d1d5db;
    padding: 1rem;
    font-size: 1rem;
    color: #1f2937;
    background-color: white;
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    resize: vertical;
  }

  .htc-custom-textarea:focus {
    border-color: #8cc540;
    box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.1);
    outline: none;
  }

  .htc-btn {
    width: 100%; 
    max-width: 300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    height: 56px;
    padding: 0.75rem 2rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .htc-btn-primary {
    background: linear-gradient(135deg, #8cc540, #8cc540);
    border: none;
    color: white;
  }

  .htc-btn-primary:hover {
    background: linear-gradient(135deg, #8cc540, #8cc540);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .htc-btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  .htc-search-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  .htc-spinner {
    width: 1.5rem;
    height: 1.5rem;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .htc-error {
    color: #b91c1c;
    border-radius: 12px;
    font-size: 0.9rem;
    white-space: pre-line;
  }

  .htc-results {
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    padding: 2rem;
    margin-top: 2rem;
  }

 

  .htc-summary-card {
    background: white;
    padding: 0.75rem;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .htc-summary-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }

  .htc-card-icon {
    width: 2rem;
    height: 2rem;
    margin-bottom: 0.75rem;
  }

  .htc-card-icon.htc-total {
    color: #4f46e5;
  }

  .htc-card-icon.htc-success {
    color: #10b981;
  }

  .htc-card-icon.htc-warning {
    color: #f59e0b;
  }

  .htc-card-icon.htc-error {
    color: #ef4444;
  }

  .htc-number {
    font-size: 1.25rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
  }

  .htc-number.htc-total {
    background: linear-gradient(135deg, #4f46e5, #7c3aed);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .htc-number.htc-success {
    color: #10b981;
  }

  .htc-number.htc-warning {
    color: #f59e0b;
  }

  .htc-number.htc-error {
    color: #ef4444;
  }

  .htc-label {
    font-weight: 600;
    color: #4b5563;
    font-size: 0.9rem;
  }

  .htc-heading-levels-overview {
    margin-bottom: 2rem;
  }

  .htc-heading-levels-overview h2 {
    font-size: 1.5rem;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 1rem;
  }

  .htc-table-wrapper {
    overflow-x: auto;
  }

  .htc-heading-levels-table {
    width: 100%;
    border-collapse: collapse;
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .htc-heading-levels-table th,
  .htc-heading-levels-table td {
    padding: 1rem;
    text-align: center;
    border: 1px solid #e5e7eb;
    font-size: 1rem;
  }

  .htc-heading-levels-table th {
    background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
    font-weight: 600;
    color: #1f2937;
  }

  .htc-heading-levels-table td {
    font-weight: 500;
    color: #374151;
  }

  .htc-tabs-container {
    background-color: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  .nav-tabs {
    background: linear-gradient(135deg, #f3f4f6, #e5e7eb);
    border-bottom: none;
  }

  .nav-tabs .nav-link {
    padding: 1rem 1.5rem;
    color: #4b5563;
    border: none;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .nav-tabs .nav-link:hover {
    background: rgba(79, 70, 229, 0.1);
    color: #4f46e5;
  }

  .nav-tabs .nav-link.active {
    background: white;
    color: #8cc540;
    border-bottom: 3px solid #8cc540;
  }

  .htc-tab-content {
    max-height: 450px;
    overflow-y: auto;
    padding: 1rem;
    scrollbar-width: thin;
    scrollbar-color: #d1d5db #f3f4f6;
  }

  .htc-tab-content::-webkit-scrollbar {
    width: 8px;
  }

  .htc-tab-content::-webkit-scrollbar-track {
    background: #f3f4f6;
    border-radius: 4px;
  }

  .htc-tab-content::-webkit-scrollbar-thumb {
    background: #d1d5db;
    border-radius: 4px;
  }

  .htc-heading-item {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.25rem;
    border-bottom: 1px solid #e5e7eb;
    background: white;
    border-radius: 8px;
    margin-bottom: 0.5rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .htc-heading-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .htc-status-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  .htc-status-icon.htc-success {
    color: #10b981;
  }

  .htc-status-icon.htc-warning {
    color: #f59e0b;
  }

  .htc-status-icon.htc-error {
    color: #ef4444;
  }

  .htc-heading-content {
    flex: 1;
  }

  .htc-heading-title {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.5rem;
  }

  .htc-heading-level {
    padding: 0.25rem 0.75rem;
    background: #e5e7eb;
    border-radius: 6px;
    font-size: 0.9rem;
    font-weight: 600;
    color: #1f2937;
  }

  .htc-heading-text {
    font-weight: 500;
    font-size: 1rem;
    color: #1f2937;
  }

  .htc-empty-heading {
    color: #6b7280;
    font-style: italic;
  }

  .htc-issues-list {
    margin-top: 0.75rem;
    font-size: 0.9rem;
    list-style: none;
    padding-left: 0;
  }

  .htc-issue {
    color: #ef4444;
  }

  .htc-issue.htc-warning {
    color: #f59e0b;
  }

  .htc-empty-tab-message {
    padding: 2rem;
    text-align: center;
    color: #6b7280;
    font-size: 1rem;
    font-style: italic;
    background: #f9fafb;
    border-radius: 8px;
  }

  .htc-fs-5 {
    font-size: 1.5rem;
    font-weight: 600;
  }

  @media (max-width: 768px) {
    .htc-container {
      padding: 1rem;
    }

    .htc-input-group {
      flex-direction: column;
      align-items: stretch;
    }

    .htc-url-input-wrapper {
      margin-bottom: 2rem;
    }

    .htc-btn {
      width: auto;
    }

    .htc-summary-grid {
      grid-template-columns: repeat(2, minmax(140px, 1fr));
      gap: 1rem;
    }

    .htc-summary-card {
      padding: 1rem;
    }

    .htc-number {
      font-size: 1.5rem;
    }

    .htc-table-wrapper {
      overflow-x: auto;
    }

    .htc-heading-levels-table th,
    .htc-heading-levels-table td {
      font-size: 0.9rem;
      padding: 0.75rem;
    }

    .htc-tab-content {
      max-height: 350px;
    }

    .nav-tabs .nav-link {
      padding: 0.75rem 1rem;
      font-size: 0.9rem;
    }
  }

    @media screen and (min-width: 770px) and (max-width: 985px) {
.htc-summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(180px, 1fr));
    gap: 1.25rem;
    margin-bottom: 2rem;
}
}
@media screen and (min-width: 986px) and (max-width: 2999px) {
 .htc-summary-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(180px, 1fr));
    gap: 1.25rem;
    margin-bottom: 2rem;
  }
}

  @media (max-width: 576px) {
    .htc-container {
      padding: 0.75rem;
    }

    .htc-toggle-btn {
      font-size: 0.9rem;
      padding: 0.5rem 1rem;
    }

    .htc-summary-card.card {
    width: 100%;
}

    .htc-custom-input,
    .htc-custom-textarea {
      font-size: 0.9rem;
      padding: 0.5rem 1rem;
      height: 48px;
      width: 100%;
    }

    .htc-custom-textarea {
      min-height: 150px;
    }

    .htc-btn {
      font-size: 0.9rem;
      height: 48px;
    }

    .htc-summary-grid {
      grid-template-columns: 1fr;
      gap: 0.75rem;
    }

    .htc-heading-levels-table th,
    .htc-heading-levels-table td {
      font-size: 0.8rem;
      padding: 0.5rem;
    }

    .htc-heading-item {
      padding: 1rem;
      font-size: 0.9rem;
    }

    .htc-error {
      font-size: 0.8rem;
    }

  }
    
.htc-toggle-btn.btn-success {
  background-color: #8cc540 !important;
  border-color: #8cc540 !important;
  color: white !important;
  transition: all 0.2s ease-in-out;
}

.htc-toggle-btn.btn-success:hover {
  background-color: #74a632 !important;
  border-color: #74a632 !important;
}

.htc-toggle-btn.btn-outline-success {
  color: #8cc540 !important;
  border-color: #8cc540 !important;
  transition: all 0.2s ease-in-out;
}

.htc-toggle-btn.btn-outline-success:hover {
  background-color: #8cc540 !important;
  color: white !important;
}
.htc-toggle-btn {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 500;
  background-color: white;
  border: 2px solid #d1d5db;
  color: #374151;
  transition: all 0.3s ease;
}

.htc-toggle-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.htc-toggle-active {
  background-color: #8cc540 !important;
  border-color: #8cc540 !important;
  color: white !important;
}



`;